var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    overflow: "visible",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.52C0 6.08942 0 3.37413 1.68706 1.68706C3.37413 0 6.08942 0 11.52 0L12.48 0C17.9106 0 20.6259 0 22.3129 1.68706C24 3.37413 24 6.08942 24 11.52V12.48C24 17.9106 24 20.6259 22.3129 22.3129C20.6259 24 17.9106 24 12.48 24H11.52C6.08942 24 3.37413 24 1.68706 22.3129C0 20.6259 0 17.9106 0 12.48L0 11.52Z",
    fill: "#0077FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7698 17.2898C7.29978 17.2898 4.1798 13.5398 4.0498 7.2998H6.78979C6.87979 11.8798 8.89976 13.8198 10.4998 14.2198V7.2998H13.0798V11.2498C14.6598 11.0798 16.3196 9.2798 16.8796 7.2998H19.4597C19.0297 9.7398 17.2297 11.5398 15.9497 12.2798C17.2297 12.8798 19.2798 14.4498 20.0598 17.2898H17.2197C16.6097 15.3898 15.0898 13.9198 13.0798 13.7198L13.0798 17.2898H12.7698Z",
    fill: "white"
  })));
};
export default SvgVk;